import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Download } from "react-feather";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProductReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllReviews`);
        if (response.data.success) {
          setReviews(response.data.reviews);
          setFilteredData(response.data.reviews);
        }
      } catch (error) {
        console.error("❌ Error fetching reviews:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, []);

  // Delete a review
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This review will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await axios.delete(`${baseurl}deleteReviewById/${id}`);
      if (response.data.success) {
        const updated = reviews.filter((item) => item.id !== id);
        setReviews(updated);
        setFilteredData(updated);
        Swal.fire("Deleted!", "Review deleted successfully.", "success");
      } else {
        Swal.fire("Error", "Failed to delete review.", "error");
      }
    } catch (error) {
      console.error("❌ Error deleting review:", error);
      Swal.fire("Error", "Something went wrong while deleting.", "error");
    }
  };

  // Download Excel
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reviews");
    XLSX.writeFile(wb, "reviews.xlsx");
  };

  // Search filter
  useEffect(() => {
    if (!search) {
      setFilteredData(reviews);
    } else {
      const filtered = reviews.filter((r) =>
        r.product_title.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [search, reviews]);

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Product Reviews</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search by Product Title"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <button className="btn btn-success" onClick={handleDownloadExcel}>
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <div className="p-3">
                  <Skeleton height={35} width="30%" style={{ marginBottom: "15px" }} />
                  <table className="custom-table w-100">
                    <thead>
                      <tr>
                        {Array(6).fill().map((_, i) => <th key={i}><Skeleton height={20} /></th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {Array(6).fill().map((_, rowIdx) => (
                        <tr key={rowIdx}>
                          {Array(6).fill().map((__, colIdx) => <td key={colIdx}><Skeleton height={20} /></td>)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ overflowX: "auto", maxHeight: "500px" }}>
                  <table className="custom-table mb-0">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Product Title</th>
                        <th>Rating</th>
                        <th>Review</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((r) => (
                          <tr key={r.id}>
                            <td>{r.id}</td>
                            <td>
                              <Link to={`/admin/seller-listing-details/${r.product_id}`}>
                                {r.product_title}
                              </Link>
                            </td>
                            <td>{r.rating}</td>
                            <td>{r.review_text}</td>
                            <td>{new Date(r.created_at).toLocaleDateString()}</td>
                            <td>
                              <div className="d-flex gap-2">
                                <Link
                                  to={`/product/${r.product_slug}`} target="_blank"
                                  className="btn btn-primary btn-sm"
                                >
                                  View Listing
                                </Link>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(r.id)}
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-3">
                            No reviews found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductReviews;
